import { baseSeriesMark } from "../base/constant";

export const circlePackingSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    circlePacking: {
        name: "circlePacking",
        type: "arc"
    }
});
//# sourceMappingURL=constant.js.map
